import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Wallet, CalendarRange, BookOpenCheck, Package, SprayCan, Tag, Thermometer } from 'lucide-react';
import { strBasePath, useStrProperty } from '../features/shortTermRentals/properties';

const ShortTermRentalsPropertyHub = () => {
  const navigate = useNavigate();
  const property = useStrProperty();
  const basePath = strBasePath(property);

  const bookingsText = `View ${property.bookingsText}.`;

  const cards = [
    { path: 'financials', title: 'Financials', text: 'Track private and company expenses, with automatic VAT calculation.', Icon: Wallet, background: '#ecfdf5', color: '#059669' },
    { path: 'planning', title: 'Planning', text: 'View all reservations on a calendar.', Icon: CalendarRange, background: '#eff6ff', color: '#2563eb' },
    { path: 'pricing', title: 'Pricing', text: 'Set nightly prices for future dates.', Icon: Tag, background: '#f5f3ff', color: '#7c3aed' },
    { path: 'bookings', title: 'Bookings', text: bookingsText, Icon: BookOpenCheck, background: '#fef3c7', color: '#d97706' },
    { path: 'cleaning', title: 'Cleaning & Maintenance', text: 'Schedule cleaning, deep cleaning, lawn mowing and other recurring checklists.', Icon: SprayCan, background: '#fdf2f8', color: '#db2777' },
    { path: 'inventory', title: 'Inventory', text: 'Items, where they are, how much is left and what was bought.', Icon: Package, background: '#fff7ed', color: '#ea580c' },
    ...(property.websiteConnected
      ? [{ path: 'smart-home', title: 'Smart Home', text: 'Room temperatures, heating and sauna controls, and planned temperature changes.', Icon: Thermometer, background: '#ecfeff', color: '#0e7490' }]
      : [])
  ];

  return (
    <div>
      <button onClick={() => navigate('/short-term-rentals')} style={backButtonStyle}>
        <ArrowLeft size={16} /> Back
      </button>

      <h1 style={{ color: property.color, marginBottom: '20px' }}>{property.name}</h1>
      <p style={{ color: '#64748b', marginBottom: '40px' }}>Select a tool to manage this property.</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {cards.map(({ path, title, text, Icon, background, color }) => (
          <div key={path} onClick={() => navigate(`${basePath}/${path}`)} style={cardStyle} className="hover-card">
            <div style={{ ...iconBoxStyle, backgroundColor: background }}>
              <Icon size={32} color={color} />
            </div>
            <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>{title}</h3>
            <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const backButtonStyle = { display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontSize: '14px', marginBottom: '20px', padding: 0 };
const cardStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)', cursor: 'pointer', transition: 'all 0.2s ease', border: '1px solid #e2e8f0', height: '100%', boxSizing: 'border-box' };
const iconBoxStyle = { width: '56px', height: '56px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' };

export default ShortTermRentalsPropertyHub;
